export const OIDC_LOGIN_PATH = "/oauth2/authorization/oicd";
const RESTORE_PAGE_KEY = "auth.restorePage";
const EXCLUDED_PATHS = ["/api", "/oauth2", "/login", "/login-error"];

export function saveCurrentPage(): void {
    const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (!isSafeAppPath(path)) return;
    try {
        sessionStorage.setItem(RESTORE_PAGE_KEY, path);
    } catch {
        // A blocked session storage must not prevent login.
    }
}

export function consumeRestorePage(): string | null {
    let path: string | null = null;
    try {
        path = sessionStorage.getItem(RESTORE_PAGE_KEY);
        sessionStorage.removeItem(RESTORE_PAGE_KEY);
    } catch {
        return null;
    }
    return path && isSafeAppPath(path) ? path : null;
}

export function isSafeAppPath(path: string): boolean {
    if (!path.startsWith("/") || path.startsWith("//")) return false;
    try {
        const url = new URL(path, window.location.origin);
        return url.origin === window.location.origin &&
            !EXCLUDED_PATHS.some(prefix => url.pathname === prefix || url.pathname.startsWith(`${prefix}/`));
    } catch {
        return false;
    }
}
